import * as React from 'react';
import {useEffect, useState} from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid,
    Stack, TextField, ToggleButton, ToggleButtonGroup, Typography
} from '@mui/material';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import {FigureAlign, FigureValue} from './QuillFigureBlot';

interface Props {
    open: boolean;
    value: FigureValue;
    onConfirm: (value: FigureValue) => void;
    onClose: () => void;
}

export const QuillImageDialog = ({open, value, onConfirm, onClose}: Props) => {
    const [width, setWidth] = useState('');
    const [caption, setCaption] = useState('');
    const [align, setAlign] = useState<FigureAlign>('');

    useEffect(() => {
        if (open) {
            setWidth(value.width || '');
            setCaption(value.caption || '');
            setAlign(value.align || '');
        }
    }, [open, value]);

    const handleConfirm = () => {
        onConfirm({...value, width, caption, align});
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth disableRestoreFocus disableScrollLock>
            <DialogTitle>Nastavení obrázku</DialogTitle>
            <DialogContent>
                <Stack spacing={2} className={'tw-pt-20'}>
                    <Grid container spacing={2}>
                        <Grid size={6} style={{display: 'flex', alignItems: 'flex-end'}}>
                            <TextField
                                label="Šířka (volitelná)"
                                value={width}
                                onChange={e => setWidth(e.target.value)}
                                placeholder="např. 300 nebo 50%"
                                size="small"
                                fullWidth
                            />
                        </Grid>
                        <Grid size={6}>
                            <Typography variant="caption" color="text.secondary">Zarovnání</Typography>
                            <br/>
                            <ToggleButtonGroup
                                value={align || null}
                                exclusive
                                onChange={(_, v) => setAlign(v ?? '')}
                                size="small"
                            >
                                <ToggleButton value="left"><FormatAlignLeftIcon fontSize="small"/></ToggleButton>
                                <ToggleButton value="center"><FormatAlignCenterIcon fontSize="small"/></ToggleButton>
                                <ToggleButton value="right"><FormatAlignRightIcon fontSize="small"/></ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                    </Grid>
                    <TextField
                        label="Popisek (volitelný)"
                        value={caption}
                        onChange={e => setCaption(e.target.value)}
                        size="small"
                        fullWidth
                        multiline
                        rows={2}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Zrušit</Button>
                <Button onClick={handleConfirm} variant="contained">Potvrdit</Button>
            </DialogActions>
        </Dialog>
    );
};
